import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faTools } from "@fortawesome/pro-regular-svg-icons";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { OmegakeittiotMachineToolInstructionGenerationDataGrid } from "src/tenantCustomizations/tenants/omegakeittiot/OmegakeittiotMachineToolInstructionGenerationDataGrid.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const OmegakeittiotShopOrderBatchContextMenuComponents = ({
	allSelectedBatchIds,
}: {
	allSelectedBatchIds: number[];
}) => {
	const { openDialog } = useGenericDialog();
	return [
		<AsyncMenuButton
			key={"rover"}
			icon={faTools}
			label={"Työstökoneohjelma (Rover)"}
			onClick={async () => {
				openDialog({
					title: "Työstökoneohjelma (Rover)",
					agentContext: {
						key: defineAgentUiContextKey("tenant.omegakeittiot.machineToolInstructions.dialog"),
						data: { shopOrderBatchIds: allSelectedBatchIds, machineType: "ROVER" },
						pathSegments: ["Työstökoneohjelma Rover"],
					},
					content: (
						<OmegakeittiotMachineToolInstructionGenerationDataGrid
							shopOrderBatchIds={allSelectedBatchIds}
							machineType={"ROVER"}
						/>
					),
				});
			}}
		/>,
		<AsyncMenuButton
			key={"selco"}
			icon={faTools}
			label={"Työstökoneohjelma (Selco)"}
			onClick={async () => {
				openDialog({
					title: "Työstökoneohjelma (Selco)",
					agentContext: {
						key: defineAgentUiContextKey("tenant.omegakeittiot.machineToolInstructions.omegakeittiotShopOrderBatchContextMenuComponents.dialog"),
						data: { shopOrderBatchIds: allSelectedBatchIds, machineType: "SELCO" },
						pathSegments: ["Työstökoneohjelma Selco"],
					},
					content: (
						<OmegakeittiotMachineToolInstructionGenerationDataGrid
							shopOrderBatchIds={allSelectedBatchIds}
							machineType={"SELCO"}
						/>
					),
				});
			}}
		/>,
	];
};
